import moment from 'moment';

export const maxDate = moment().add(6, 'months');
export const minDate = moment().subtract(6, 'months');
